import React from 'react'

export default function FilterIcon() {
  return (
    <svg className='icons icons24x24'>
      <use xlinkHref='#filter' />
    </svg>
  )
}
